import React, { useState, useEffect } from "react";
import Iframe from 'react-iframe'
import dataProvider from "../../services/DataProvider";

import Navigation from "../../components/Navigation";
import FormExterno from "../../components/FormExterno";

const FaleConosco = () => {

    const [src, setSrc] = useState([])

    useEffect(() => {

        dataProvider.getAll('WsSanEndPoints.rule?sys=SAS').then((response) => {
            console.log(response.data.faleConosco)
            if (typeof response.data.faleConosco !== 'undefined') {
                setSrc(response.data.faleConosco)

            }

        })

    }, []);

    return (
        < >
           
           <Navigation titulo="Fale Conosco"/>

            <FormExterno src={src}/>
            
        </>
    )
}

export default FaleConosco;
